/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnChanges, type OnInit, type SimpleChanges, Component, EventEmitter, Input, Output } from '@angular/core';

import { type GraphNode } from './type';


@Component({
    selector: 'app-graph-tree',
    templateUrl: './graph-tree.component.html',
    styleUrls: ['./graph-tree.component.scss'],
})
export class GraphTreeComponent implements OnInit, OnChanges {
    /**
     * 根节点数组
     */
    @Input() root: GraphNode[];
    /**
     * 选中项
     */
    @Input() selection: GraphNode[];
    @Output() selectionChange = new EventEmitter<GraphNode[]>();
    /**
     * 节点点击选中事件
     */
    @Output() onNodeSelect = new EventEmitter<GraphNode>();

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selection) {
            if (!this.selection) {
                return;
            }

            this.clearSelection();
            this.selection.forEach((node) => {
                if (node) {
                    node.selected = true;
                }
            });
        }
    }

    /**
     * 选中点击的节点
     * @param node 点击的节点
     */
    selectNode(node: GraphNode): void {
        this.clearSelection();
        node.selected = true;

        this.selection = [node];
        this.selectionChange.emit(this.selection);
        this.onNodeSelect.emit(node);
    }

    /**
     * 选中指定的节点数组
     * @param nodes 节点数组
     */
    selectNodes(nodes: GraphNode[]): void {
        this.clearSelection();
        nodes.forEach((node) => {
            node.selected = true;
        });

        this.selection = nodes;
        this.selectionChange.emit(this.selection);
    }

    /**
     * 清空所有选中项
     */
    clearSelection(): void {
        this.clearNodesSelect(this.root);
    }

    /**
     * 清空选中
     * @param nodes 节点数字组
     */
    private clearNodesSelect(nodes: GraphNode[]): void {
        nodes.forEach((node) => {
            node.selected = false;
            if (!node.children) {
                return;
            }

            // 递归清除
            this.clearNodesSelect(node.children);
        });
    }
}
